import { AxiosResponse } from "axios";
import { useState } from "react";
import { ErrorUtils, extractFilenameFromResponse } from "../../../../../utils";
import { AvisLoader } from "../../loader/AvisLoader";
import { InteractiveBlock } from "../InteractiveBlock";

interface IAvisFileDownloadProps {
  fileName?: string;
  title?: string;
  asImage?: boolean;
  callApiOnClick: () => Promise<AxiosResponse<object, any>>;
}
export default function AvisFileDownload(
  props: Readonly<IAvisFileDownloadProps>,
) {
  const { title, fileName, asImage, callApiOnClick } = props;
  const [isDownloading, setIsDownloading] = useState<boolean>(false);

  const renderDownloadElement = () => {
    if (!asImage) {
      return title ?? fileName;
    }
    return <i className="fa fa-download" />;
  };

  return (
    <InteractiveBlock
      className="avis-navigation-link"
      asLink
      onClick={() => {
        setIsDownloading(true);
        callApiOnClick()
          .then((response) => {
            // create file link in browser's memory
            //get filename from axios response headers
            const contentDisposition = response.headers["content-disposition"];
            const filenameFromResponse =
              extractFilenameFromResponse(contentDisposition) ?? fileName ?? "";

            const fileType = response.headers["content-type"];
            const blob = new Blob([response.data as BlobPart], {
              type: fileType,
            });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;

            a.download = filenameFromResponse;

            a.click();
            window.URL.revokeObjectURL(url);
          })
          .catch((err) => ErrorUtils.getGeneralErrorMessage(err))
          .finally(() => setIsDownloading(false));
      }}
    >
      <div title={fileName}>{renderDownloadElement()}</div>
      {isDownloading && <AvisLoader />}
    </InteractiveBlock>
  );
}
